export const MODALS = {
  DELETE_USER: 'deleteUser',
  CREATE_CASE_REPORT: 'createCaseReport',
  DELETE_ASSIGNED_PROFESSIONAL: 'deleteAssignedProfessional',
  CLOSE_CASE: 'closeCase'
};
